class tabsHelper {
	constructor() {
		this.bindTabHandler();
		//this.bindAccusoftDemo();
	}
	bindTabHandler() {
		var manualSwitch = false;
		var hashArray = [];
		var _this = this;

		var showTab = function() {
			manualSwitch = true;
			hashArray = window.location.hash.split('#');
			$('.nav-tabs[data-retain-navigation] a[href="#'+hashArray[1]+'"]').tab('show');
		};

		// Javascript to enable link to tab
		if($('.nav-tabs[data-retain-navigation]').length > 0) {
			window.location.hash && showTab();	
			window.addEventListener('hashchange', showTab);
		}

		
		$('.nav-tabs[data-retain-navigation] a').on('shown.bs.tab', function (e) {

			//_this.bindAccusoftDemo();

			if(!manualSwitch) {
				if(history.pushState) {
					history.pushState(null, null, e.target.hash); 
				} else {
					window.location.hash = e.target.hash; //Polyfill for old browsers
				}	
			}
			manualSwitch = false;
			if(hashArray.length > 2) {
				// scroll to nested id
				$('html, body').animate({
					scrollTop: $('#' + hashArray[2]).offset().top - 199
				}, 500);
			} else {
				// scroll to top of tabs
				$('html, body').animate({
					scrollTop: $('#tabContentPane').offset().top - 199
				}, 500);
			}
			
		});

		$.each($('[data-mobile-selection]'), function(index, tabs) {
			var selectedTabCollapse = $(tabs).find('.collapse');
			var selectedTabText = $(tabs).find('.selected-tab span');
			$(tabs).find('.nav-tabs a').on('shown.bs.tab', function (e) {
				selectedTabCollapse.collapse('hide');
				selectedTabText.text($(e.target).text());
			});
		});
		

		
		var tabs = $('section.content-tabs .nav-tabs');
		var priorSiblingsHeight = $('section.content-tabs').prev().outerHeight(true);
		if(tabs.length > 0) {
			$(window).scroll(function (event) {
				if((tabs.offset().top - 149) - priorSiblingsHeight > 0) {
					tabs.addClass('sticky');
				} else {
					tabs.removeClass('sticky');
				}
			});
		}

	}

	// bindAccusoftDemo() {
	// 	if(window.Accusoft && window.Accusoft.PdfViewerControl) {
	// 		console.log("reload viewer demo");
	// 		document.getElementById('viewer').innerHTML = "";
	// 		this.pdfViewer = window.Accusoft.PdfViewerControl.create({
	// 			sourceDocument: 'https://docs.google.com/document/d/1j3hxgKUrxeg2SbdQ9FMl8GXLnrNlIdBd8cGrscjXGBA/export?format=pdf',
	// 			container: document.getElementById('viewer')
	// 		});
	// 	}
	// }
}
window.app.add('tabs', new tabsHelper());